import { SiteHeader } from "@/components/site-header"
import { FleetStatsSection } from "@/components/fleet-stats-section"
import { OpsStatsSection } from "@/components/ops-stats-section"

export default function DashboardPage() {
  return (
    <>
      <SiteHeader title="Dashboard" />
      <div className="flex flex-1 flex-col">
        <div className="@container/main flex flex-1 flex-col gap-2">
          <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
            <OpsStatsSection />
            <FleetStatsSection />
          </div>
        </div>
      </div>
    </>
  )
}
